<template>
  <div>
    <van-tabs ref="vantTabsRef" v-model="active" color="#FF142D" title-inactive-color="#2e2e33"
      title-active-color="#FF142D" @click="onClickTab" >
      <van-tab v-for="item in data.swiperList" :key="item.title" :title="item.title" />
    </van-tabs>
    <div class="swiper-container" :style="{ height: (data.height ) / 16 + 'rem', marginBottom: (data.marginBottom ) / 16 + 'rem' }">
      <swiper ref="imageSwiper" class="swiper" :options="adOption">
        <swiper-slide v-for="(item, index) in data.swiperList" :key="index" class="item">
          <img :src="item.img">
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';
export default {
  components: { swiper, swiperSlide },
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      active: 0,
      adOption: {
        loop: true,
        observer: true,
        observeParents: true,
        autoplay: {
          deplay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        on: {
          slideChange: () => {
            // console.log('this.swiper.realIndex',this.swiper.realIndex);
            this.$refs.vantTabsRef.scrollTo(this.swiper.realIndex);
          }
        }
      },
    }
  },
  computed: {
    swiper() {
      return this.$refs.imageSwiper.swiper
    }
  },
  methods: {
    onClickTab(index) {
      console.log('index',index);
      this.swiper.slideToLoop(index)
    }
  }
}
</script>

<style lang="less" scoped>
.swiper-container {
  width: 100%;
  position: relative;

  .swiper {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;

    .item {
      width: 100%;
      height: 100%;
      color: #fff;
      border-radius: 8px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
    }
  }

  .swiper-pagination {
    width: 100%;
    left: 0;
    bottom: 0;
  }
}
</style>

<style>
.ad-pagination {
  width: 4px;
  height: 4px;
  border-radius: 2px;
  display: inline-block;
  background-color: #fff;
  margin: 0 5px;
}

.ad-pagination-active {
  width: 12px;
  background-color: #fff;
}
</style>
